export const dataLayerPush = (pushArguments) => {
    // eslint-disable-next-line no-undef
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(pushArguments)
}